import { Box, BoxProps, ColorOptions, Icon, IconNew, Spacer, Text, TextNew } from '@jfs/ui-new'
import { useFocusEffect } from '@react-navigation/core'
import { useNavigation } from '@react-navigation/native'
import { useCallback, useEffect, useState } from 'react'
import { FlatList } from 'react-native'
import { ModalAlertView } from '../../components/ModalAlertView'
import { useLazyApiData, useStores } from '../../data/store'
import { convertSnakeCaseToCaps, convertToCaps, isAccessible } from '../../utils'

const renderItem = ({ item, index }: any) => {
  return (
    <Box flexDirection={'row'} borderTopWidth={index === 0 ? 0 : 1} borderTopColor={'DISABLED_GREY'}>
      <Box
        bg={'BACKGROUND'}
        p={16}
        borderTopLeftRadius={8}
        borderBottomLeftRadius={8}
        f={0.15}
        borderRightWidth={1}
        borderRightColor={'DISABLED_GREY'}>
        <Box flexDirection={'row'}>
          <IconNew
            id={item?.titleAccessible ? 'ROUND_TICK' : 'CLEAR'}
            color={item?.titleAccessible ? 'PRIMARY' : 'PRIMARY_GREY'}
            size={16}
          />
          <Spacer direction="horizontal" size={8} />
          <TextNew
            title={convertSnakeCaseToCaps(item?.title)}
            fontFamily="jiotype-medium"
            color={'PRIMARY_GREY'}
            fontSize={12}
          />
        </Box>
      </Box>
      <Box flexDirection={'column'} ph={16} f={0.85} pv={8}>
        {item.subTitleData.map((item: any) => {
          const objKeys = Object.keys(item)?.filter((key) => key !== 'titleAccessible' && key !== 'title')
          return (
            <Box flexDirection={'column'} pv={8} align="flex-start">
              <Box flexDirection={'row'}>
                <IconNew
                  id={item?.titleAccessible ? 'ROUND_TICK' : 'CLEAR'}
                  color={item?.titleAccessible ? 'PRIMARY' : 'PRIMARY_GREY'}
                  size={16}
                />
                <Spacer direction="horizontal" size={8} />
                <TextNew
                  title={convertSnakeCaseToCaps(item?.title)}
                  fontFamily="jiotype-medium"
                  color={'PRIMARY_GREY'}
                  fontSize={12}
                />
              </Box>
              <Box
                paddingHorizontal={24}
                marginTop={12}
                flexDirection={'row'}
                justifyContent={'space-between'}
                w={'100%'}>
                {objKeys?.map((obj: any) => {
                  return (
                    <Box flexDirection={'row'}>
                      <IconNew
                        id={item[obj] ? 'ROUND_TICK' : 'CLEAR'}
                        color={item[obj] ? 'PRIMARY' : 'PRIMARY_GREY'}
                        size={16}
                      />
                      <Spacer direction="horizontal" size={8} />
                      <TextNew
                        title={convertToCaps(obj)}
                        fontFamily="jiotype-medium"
                        color={'PRIMARY_GREY'}
                        fontSize={12}
                      />
                    </Box>
                  )
                })}
              </Box>
            </Box>
          )
        })}
      </Box>
    </Box>
  )
}
const Details = (props: any) => {
  const { getDetails, accessConfig, deleteUser, fetchUserDetails } = useStores((store) => ({
    getDetails: store.userManagement.getUserDetails,
    deleteUser: store.userManagement.userDelete,
    fetchUserDetails: store.userManagement.fetchUserDetails,
    accessConfig: store.user.getAccessConfig(['access_management', 'user']),
  }))
  const { route } = props
  const { id } = route?.params ?? ''
  localStorage.setItem('params', id)

  const navigation = useNavigation()
  const [toggleDelete, setDelete] = useState(false)
  const [deleteApi, deletepiHandler] = useLazyApiData(deleteUser)
  const [userDetailsApi, userdetailsApiHandler] = useLazyApiData(fetchUserDetails)

  useFocusEffect(
    useCallback(() => {
      !!id && userDetailsApi(id)
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [navigation, id]),
  )

  useEffect(() => {
    if (deletepiHandler.state === 'fulfilled') {
      setDelete(false)
      navigation.navigate('users')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletepiHandler.state])

  const data = getDetails(id)

  if (userdetailsApiHandler?.state === 'pending') {
    return (
      <Text textAlign={'center'} title={'Loading...'} color={'BLACK_21'} fontFamily={'jiotype-bold'} fontSize={16} />
    )
  }
  return (
    <Box bg={'WHITE'} borderRadius={8} maxHeight={'75vh'} p={16} overflow={'auto'}>
      <ModalAlertView
        show={toggleDelete}
        onDismiss={() => setDelete(false)}
        onCancel={() => setDelete(false)}
        title="Delete User"
        message={`Is this final. This will delete user with ID ${id}`}
        onPress={() => deleteApi(id)}
        buttonTitle="Delete"
        isLoading={deletepiHandler.state === 'pending'}
      />
      <Text title={`User ID: ${data?.name}`} fontSize={28} fontWeight={'600'} color={'#5a5c69' as ColorOptions} />
      <Spacer direction={'vertical'} size={16} />
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        {...styles.header}
        bg={'#f8f9fc' as ColorOptions}
        paddingHorizontal={24}
        paddingVertical={16}>
        <Box flexDirection="row" alignSelf="flex-end">
          {isAccessible(accessConfig, 'update_user') && (
            <Box
              flexDirection="row"
              backgroundColor="ORANGE"
              padding={8}
              borderRadius={4}
              onPress={() => navigation.navigate('addusers', { id: id })}
              underlayColor="YELLOW">
              <Icon id="EDIT" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Edit</Text>
            </Box>
          )}
          <Spacer direction="horizontal" size={16} />
          {isAccessible(accessConfig, 'delete_user') && (
            <Box
              flexDirection="row"
              backgroundColor="RED"
              padding={8}
              borderRadius={4}
              onPress={() => setDelete(true)}
              underlayColor="ERROR">
              <Icon id="DELETE" size="FONT_SIZE_LARGE" color="WHITE" />
              <Spacer direction="horizontal" size={4} />
              <Text color="WHITE">Delete</Text>
            </Box>
          )}
        </Box>
      </Box>

      <Box {...styles.container}>
        {data?.accessConfig?.length === 0 && (
          <Box p={16}>
            <Text textAlign="center">{'No Details found'}</Text>
          </Box>
        )}
        {data?.accessConfig?.length > 0 && <FlatList data={data?.accessConfig} renderItem={renderItem} />}
      </Box>
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}

export default Details
